export default __webpack_public_path__ + "static/media/roboto-v20-latin-100italic.370619fc.ttf";